import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

interface IconProps {
  size?: number
  color?: string
}

const ExpiredOutlined = ({ size = 24, color = '#ED6C5B' }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 13 12"
    fill="none"
  >
    <Path
      d="M0.333343 3.49991C0.333343 3.22376 0.634606 2.99991 1.00624 2.99991L11.6604 2.99991C12.0321 2.99991 12.3333 3.22376 12.3333 3.49991C12.3333 3.77606 12.0321 3.99991 11.6604 3.99991L1.00624 3.99991C0.634606 3.99991 0.333343 3.77606 0.333343 3.49991Z"
      fill={color}
    />
    <Path
      d="M6.37336 4.69986C6.64949 4.69986 6.87333 4.9237 6.87333 5.19984V7.69971C6.87333 7.97585 6.64949 8.19969 6.37336 8.19969C6.09722 8.19969 5.87338 7.97585 5.87338 7.69971V5.19984C5.87338 4.9237 6.09722 4.69986 6.37336 4.69986Z"
      fill={color}
    />
    <Path
      d="M6.3733 9.66264C6.64943 9.66264 6.87327 9.4388 6.87327 9.16266C6.87327 8.88653 6.64943 8.66269 6.3733 8.66269C6.09716 8.66269 5.87332 8.88653 5.87332 9.16266C5.87332 9.4388 6.09716 9.66264 6.3733 9.66264Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.93334 0.599908C6.93334 0.268534 6.66472 -9.15527e-05 6.33334 -9.15527e-05C6.00196 -9.15527e-05 5.73334 0.268534 5.73334 0.599908H3.93334C3.93334 0.268534 3.66471 -9.15527e-05 3.33334 -9.15527e-05C3.00198 -9.15527e-05 2.73334 0.268534 2.73334 0.599908C1.40786 0.599908 0.333344 1.67442 0.333344 2.99991V9.59991C0.333344 10.9254 1.40786 11.9999 2.73334 11.9999H9.93334C11.2588 11.9999 12.3333 10.9254 12.3333 9.59991V2.99991C12.3333 1.67442 11.2588 0.599908 9.93334 0.599908C9.93334 0.268534 9.66472 -9.15527e-05 9.33334 -9.15527e-05C9.00196 -9.15527e-05 8.73334 0.268534 8.73334 0.599908H6.93334ZM2.73334 1.79991C2.0706 1.79991 1.53334 2.33717 1.53334 2.99991V9.59991C1.53334 10.2627 2.0706 10.7999 2.73334 10.7999H9.93334C10.5961 10.7999 11.1333 10.2627 11.1333 9.59991V2.99991C11.1333 2.33717 10.5961 1.79991 9.93334 1.79991C9.93334 2.13128 9.66472 2.39991 9.33334 2.39991C9.00196 2.39991 8.73334 2.13128 8.73334 1.79991H6.93334C6.93334 2.13128 6.66472 2.39991 6.33334 2.39991C6.00196 2.39991 5.73334 2.13128 5.73334 1.79991H3.93334C3.93334 2.13128 3.66471 2.39991 3.33334 2.39991C3.00198 2.39991 2.73334 2.13128 2.73334 1.79991Z"
      fill={color}
    />
  </Svg>
)

export default ExpiredOutlined
